require('./menu-item-prices/menu-item-prices.scss');
var ShoppingCartMenu = require('./menu-item-prices/shopping-cart-menu');
var MenuItemPrice = require('./menu-item-prices/menu-item-price');
var MenuItemPriceLocationCheck = require('./menu-item-prices/menu-item-price-location-check');

var MenuItemPrices = Marionette.CollectionView.extend({
    className:
        'fmcy-menu-item-prices',
    childView: MenuItemPrice,
    childEvents: {
        'price:clicked': 'onPriceClicked'
    },
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                size: 'default', // default | large
                onlinePurchaseEnabled: false,
                variantShowInStockIfAtAnyLocation: false,
                filterLocation: null,
                hideOutOfStockVariation: true,
                menuItemPriceLayout: undefined,
                menuItemPriceLayoutSinglePrice: undefined,
                align: 'center',
                style: 'default', //default | checks
                theme: 'default' // default | dark
            }
        );

        var filterLocation = this.options.filterLocation;

        var locations = self.options.appChannel.request('get:locations');

        locations.each(function(location) {
          if (location.get('slug') === filterLocation) {
            self.options.locationId = location.get('id');
          }
        });
    },
    onPriceClicked: function(view) {
        if (!this.options.onlinePurchaseEnabled){
            return;
        }

        if (view.options.variantOutOfStockAtFilteredLocation !== true) {
          this.itemAddToCart(view.model, view.options.menuItemModel);
          if (this.options.appChannel.request('is:user:logged:in') == true) {
            var childView = this.children.findByModel(view.model);
            if (childView) {
                childView.displayAddedAnimation();
            }
          }
        }
    },
    itemAddToCart: function(variantModel, menuItemModel) {
        this.options.appChannel.trigger(
            'cart:add:item', variantModel, menuItemModel
        );
    },
    onRender: function() {
        this.$el.addClass('fmcy-menu-item-prices-size-' + this.options.size);
        this.$el.addClass('fmcy-menu-item-prices-theme-' + this.options.theme);
        if (this.options.align === 'left') {
          this.$el.addClass('fmy-menu-item-prices-align-left');
        }
        if (this.options.style === 'checks') {
          this.$el.addClass('fmy-menu-item-prices-checks');
        }

    },
    childViewOptions: function(model, index) {
      var self = this;
        var options = _.extend(
            { modelIndex: index },
            this.options
        );
        if (this.options.filterLocation !== null) {
          if (this.options.locationId !== null) {
              var variantOutOfStockAtFilteredLocation = false
              if (!model.get('locations')) {
                variantOutOfStockAtFilteredLocation = true;
              } else {
                var variation_at_location = false;
                _.each(model.get('locations'), function (location) {
                  if (self.options.variantShowInStockIfAtAnyLocation == true) {
                    if (parseInt(location.quantity) > 0) {
                      variation_at_location = true;
                    }
                  } else {

                    if (location.location_id == self.options.locationId && parseInt(location.quantity) > 0 && (parseInt(location.quantity) >= parseInt(location.order_level_minimum))) {
                      variation_at_location = true;
                    }

                    if (location.location_id == self.options.locationId && location.out_of_stock_at_selected_location == true) {
                      variation_at_location = false;
                    }

                  }
                });
                if (!variation_at_location) {
                  variantOutOfStockAtFilteredLocation = true;
                }
              }

              options = _.extend(options, {
                variantOutOfStockAtFilteredLocation: variantOutOfStockAtFilteredLocation
              });
          }

          if (this.collection.size() === 1) {
              options = _.extend(options, { layout: this.options.menuItemPriceLayoutSinglePrice });
          } else if (this.options.menuItemPriceLayout) {
              options = _.extend(options, { layout: this.options.menuItemPriceLayout });
          }
        }

        return options;
    },
    buildChildView: function (model, ChildViewClass, childViewOptions) {
        var self = this;

        var options = _.extend({
            model: model
        }, childViewOptions);

        var view;
        switch (options.style) {
          case 'checks':
            view = new MenuItemPriceLocationCheck(options);
          break;
          default:
            view = new MenuItemPrice(options);
          break;
        }

        return view;
    }
});
module.exports = MenuItemPrices;



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/common/menu-item-prices.js
 **/